import type { IconProps } from './icon.types'

const EyeIcon = (props: IconProps) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='eye-icon'
    {...props}
  >
    <path d='M1.5 9S4.5 4 9 4s7.5 5 7.5 5-3 5-7.5 5S1.5 9 1.5 9z' />
    <circle cx='9' cy='9' r='2.4' />
  </svg>
)

export default EyeIcon
